import { render, staticRenderFns } from "./EmptySerumConfirmationModal.vue?vue&type=template&id=0da34c82&scoped=true"
import script from "./EmptySerumConfirmationModal.vue?vue&type=script&lang=js"
export * from "./EmptySerumConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./EmptySerumConfirmationModal.vue?vue&type=style&index=0&id=0da34c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da34c82",
  null
  
)

export default component.exports